import apiRequest from "../../helpers/apiRequest";

export default async (email) => {
    return await apiRequest({
        method: 'post',
        url: `content/subscribe/`,
        data: email
    })
}
